"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13591],{

/***/ 94970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);
/* harmony import */ var features_register_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28456);



// API

// Constants

// Actions
var CONTEXT = "@register/registerForm";
var actionType = {
    VALIDATE_FIELD: "".concat(CONTEXT, "/VALIDATE_FIELD")
};
// Initial state
var initialState = {
    validations: {
        fullname: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        email: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        username: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx,
        password: features_register_constants__WEBPACK_IMPORTED_MODULE_2__/* .validationReqSchema */ .wx
    }
};
// Reducers (define how the state changes)
var reducers = {
    storeFieldValidation: function(state, action) {
        var ref, ref1;
        var field = action.payload.field;
        var ref2;
        state.validations[field].error = (ref2 = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.error) !== null && ref2 !== void 0 ? ref2 : null;
        state.validations[field].isChecked = true;
        state.validations[field].isLoading = false;
        var ref3;
        state.validations[field].message = (ref3 = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref3 !== void 0 ? ref3 : null;
    },
    resetFieldValidation: function(state, action) {
        var field = action.payload.field;
        state.validations[field].error = null;
        state.validations[field].isChecked = false;
        state.validations[field].isLoading = false;
        state.validations[field].message = null;
    },
    resetAllValidations: function() {
        return initialState;
    }
};
// Effects (thunks / async operations that needs side effects)
var effects = {
    // field validation
    validateField: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.VALIDATE_FIELD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var field, value, tempKey, ref, message, ref1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        field = param.field, value = param.value, tempKey = param.tempKey;
                        _ctx.prev = 1;
                        if (!(!field || !value)) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("The ".concat(field, " field is required"));
                    case 4:
                        if (!(field === "password" && value.length < 6)) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Password harus terdiri dari minimal 6 karakter");
                    case 6:
                        if (!(field === "password" && value.length > 18)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Password harus terdiri dari maksimal 18 karakter");
                    case 8:
                        _ctx.next = 10;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].validateRegisterForm */ .Z.validateRegisterForm(field, value, tempKey);
                    case 10:
                        ref = _ctx.sent;
                        message = ref.data;
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        return _ctx.abrupt("return", Promise.reject((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Selectors (getters)
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function(state) {
    return {
        validations: state.register.emailRegister.validations
    };
}, function(email) {
    return email;
});
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    builder.addCase(effects.validateField.pending, function(draft, action) {
        var _arg = action.meta.arg, field = _arg.field, value = _arg.value;
        if (!draft.validations[field].error) {
            draft.validations[field].data = value;
            draft.validations[field].isChecked = false;
        }
        draft.validations[field].isLoading = true;
    }).addCase(effects.validateField.fulfilled, function(draft, action) {
        var message = action.payload.message;
        var field = action.meta.arg.field;
        draft.validations[field].error = null;
        draft.validations[field].isChecked = true;
        draft.validations[field].isLoading = false;
        draft.validations[field].message = message;
    }).addCase(effects.validateField.rejected, function(draft, action) {
        var message = action.error.message, _meta = action.meta, field = _meta.arg.field;
        draft.validations[field].error = message;
        draft.validations[field].isChecked = true;
        draft.validations[field].isLoading = false;
        draft.validations[field].message = null;
    });
};
var emailRegisterSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "emailRegister",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (emailRegisterSlice);


/***/ }),

/***/ 28456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AY": function() { return /* binding */ newRegisterTypes; },
/* harmony export */   "E8": function() { return /* binding */ registerTypes; },
/* harmony export */   "HH": function() { return /* binding */ emailVerifyStatus; },
/* harmony export */   "Io": function() { return /* binding */ mappingNewRegisterTypes; },
/* harmony export */   "N3": function() { return /* binding */ errorMessage; },
/* harmony export */   "b_": function() { return /* binding */ LS_PHONE_REGISTER; },
/* harmony export */   "cs": function() { return /* binding */ emailStatuses; },
/* harmony export */   "eP": function() { return /* binding */ hints; },
/* harmony export */   "hb": function() { return /* binding */ LS_EMAIL_REGISTER; },
/* harmony export */   "o_": function() { return /* binding */ formTypes; },
/* harmony export */   "w7": function() { return /* binding */ phoneVerifyStatus; },
/* harmony export */   "wx": function() { return /* binding */ validationReqSchema; }
/* harmony export */ });
/* unused harmony export requestSchema */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);



var formTypes = {
    SELECTION: "SELECTION_FORM",
    EMAIL: "EMAIL_FORM",
    PHONE: "PHONE_FORM",
    SEND_OTP_METHOD: "SEND_OTP_METHOD",
    CHECK_PHONE: "CHECK_PHONE_FORM",
    NOTIFY_VERIFICATION_PHONE: "NOTIFY_VERIFICATION_PHONE",
    NOTIFY_VERIFICATION_EMAIL: "NOTIFY_VERIFICATION_EMAIL",
    VERIFY_EMAIL: "VERIFY_EMAIL_FORM",
    VERIFY_PHONE: "VERIFY_PHONE_FORM",
    PROFILE_PHOTO: "PROFILE_PHOTO_FORM",
    CONNECT_FB: "CONNECT_FB_FORM",
    DISCOVER_PEOPLE: "DISCOVER_PEOPLE_FORM",
    DISCOVER_STOCK: "DISCOVER_STOCK_FORM",
    LOADING: "LOADING_FORM",
    SUCCESS: "SUCCESSFUL_REGISTRATION",
    PHONE_ERROR: "PHONE_ERROR_FORM",
    OTP_LIMIT: "OTP_LIMIT"
};
var registerTypes = {
    EMAIL: "email",
    GOOGLE: "google",
    FACEBOOK: "facebook"
};
var newRegisterTypes = {
    EMAIL: "IDENTITY_TYPE_EMAIL",
    GOOGLE: "IDENTITY_TYPE_GOOGLE",
    FACEBOOK: "IDENTITY_TYPE_FACEBOOK"
};
var emailVerifyStatus = {
    SIGNIN: "STATE_CHECK_EMAIL_SIGNIN",
    REGISTER: "STATE_CHECK_EMAIL_SIGNIN"
};
var phoneVerifyStatus = {
    FAIL: "VERIFY_STATUS_FAIL",
    SUCCESS: "VERIFY_STATUS_SUCCESS"
};
var _obj;
var mappingNewRegisterTypes = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.EMAIL, newRegisterTypes.EMAIL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.GOOGLE, newRegisterTypes.GOOGLE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.FACEBOOK, newRegisterTypes.FACEBOOK), _obj);
var requestSchema = {
    data: null,
    isLoading: false,
    message: "",
    error: ""
};
var validationReqSchema = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, requestSchema), {
    isChecked: false
});
var hints = {
    NAME: {
        title: "What's Your Name",
        description: "Using your real name makes it easier for you to be recognised and build a network."
    },
    EMAIL: {
        title: "What's Your Email",
        description: "You will need your email to login and reset your password in the future."
    },
    USERNAME: {
        title: "Pick a Username",
        description: "Your username is your brand. Pick one that is professional and credible. You cannot change it later."
    },
    PASSWORD: {
        title: "Create a Password",
        description: "Your password needs to be at least 6 or more characters long. Pick a password that you can remember."
    }
};
var errorMessage = {
    EMAIL_REGISTERED: "Email ini sudah pernah terdaftar di Stockbit. Silahkan coba login.",
    PHONE_REGISTERED: "Nomor telepon ini sudah pernah terdaftar di Stockbit. Silahkan coba login.",
    FAIL_TO_VERIFY_PHONE: "Gagal verifikasi nomor telepon. Silahkan coba lagi.",
    FAIL_TO_VERIFY_EMAIL: "Gagal verifikasi email. Silahkan coba lagi.",
    SOCIAL_ACCOUNT_REGISTERED: "Akun social sudah terdaftar, silakan gunakan akun social lain",
    SOCIAL_EMAIL_REGISTERED: "Email Sudah Terdaftar"
};
var emailStatuses = {
    VERIFIED: "verified",
    NOT_VERIFIED: "not_verified"
};
var LS_EMAIL_REGISTER = "emailRegister";
var LS_PHONE_REGISTER = "phoneRegister";



/***/ }),

/***/ 9260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ register_slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: rootSlice

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/lib/api/auth.js
var auth = __webpack_require__(6242);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/lib/api/authNext.ts + 1 modules
var authNext = __webpack_require__(39762);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/features/register/utils.ts
var utils = __webpack_require__(7865);
// EXTERNAL MODULE: ./src/features/register/constants.ts
var constants = __webpack_require__(28456);
// EXTERNAL MODULE: ./src/features/register/EmailRegister/slice.ts
var slice = __webpack_require__(94970);
;// CONCATENATED MODULE: ./src/features/register/types.ts
var VerifyPhoneErrorType;
(function(VerifyPhoneErrorType) {
    VerifyPhoneErrorType["OtpLimit"] = "OTP_LIMIT";
})(VerifyPhoneErrorType || (VerifyPhoneErrorType = {}));

;// CONCATENATED MODULE: ./src/features/register/slice.ts
/* eslint-disable no-use-before-define */ 





// API





// Constants





// Store


// Actions
var CONTEXT = "@register";
var actionType = {
    SUBMIT: "".concat(CONTEXT, "/submit"),
    RESEND: "".concat(CONTEXT, "/resend"),
    VERIFY: "".concat(CONTEXT, "/verify"),
    VERIFY_REGISTRATION: "".concat(CONTEXT, "/verify_registration"),
    VERIFY_EMAIL_OTP: "".concat(CONTEXT, "/verify_email_otp"),
    RESEND_EMAIL_OTP: "".concat(CONTEXT, "/resend_email_otp"),
    VERIFY_PHONE: "".concat(CONTEXT, "/verify_phone"),
    VERIFY_PHONE_OTP: "".concat(CONTEXT, "/verify_phone_otp"),
    RESEND_PHONE_OTP: "".concat(CONTEXT, "/resend_phone_otp")
};
// Initial state
var initialState = {
    currentForm: constants/* formTypes.SELECTION */.o_.SELECTION,
    type: constants/* registerTypes.EMAIL */.E8.EMAIL,
    accountid: "",
    accountkey: "",
    fullname: "",
    email: "",
    username: "",
    password: "",
    passwordConf: "",
    phoneNumber: "",
    channel: null,
    code: "62",
    country: "",
    exchange: "",
    supportId: "",
    captchaToken: "",
    captchaVersion: 3,
    tempKey: "",
    emailStatus: ""
};
// Reducers (define how the state changes)
var reducers = {
    changeForm: function(state, action) {
        state.currentForm = action.payload.target;
    },
    storeProfile: function(state, action) {
        var _payload = action.payload, nextForm = _payload.nextForm, fullname = _payload.fullname, email = _payload.email, username = _payload.username, password = _payload.password, passwordConf = _payload.passwordConf, tempKey = _payload.tempKey, emailStatus = _payload.emailStatus;
        state.currentForm = nextForm;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.password = password;
        state.passwordConf = passwordConf;
        state.tempKey = tempKey;
        state.emailStatus = emailStatus;
    },
    storeSocialIdentities: function(state, action) {
        var _payload = action.payload, type = _payload.type, accountid = _payload.accountid, accountkey = _payload.accountkey, fullname = _payload.fullname, email = _payload.email, username = _payload.username, error = _payload.error;
        state.type = type;
        state.accountid = accountid;
        state.accountkey = accountkey;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.error = error;
    },
    storePhoneNumber: function(state, action) {
        var _payload = action.payload, phoneNumber = _payload.phoneNumber, country = _payload.country;
        state.currentForm = constants/* formTypes.NOTIFY_VERIFICATION_PHONE */.o_.NOTIFY_VERIFICATION_PHONE;
        state.phoneNumber = phoneNumber;
        state.country = country.iso2;
    },
    storeCaptchaToken: function(state, action) {
        state.captchaToken = action.payload.token;
    },
    storeEmailVerifData: function(state, action) {
        state.tempKey = action.payload.tempKey;
        state.emailStatus = action.payload.emailStatus;
    },
    storeAllData: function(state, action) {
        return action.payload;
    },
    savePhoneNumber: function(state, action) {
        var _payload = action.payload, phoneNumber = _payload.phoneNumber, code = _payload.code;
        state.currentForm = constants/* formTypes.SEND_OTP_METHOD */.o_.SEND_OTP_METHOD;
        state.phoneNumber = phoneNumber;
        state.code = code;
        (0,utils/* storeData */.xG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            currentForm: constants/* formTypes.PHONE */.o_.PHONE
        }));
    },
    resetAllData: function() {
        return initialState;
    }
};
// Effects (thunks / async operations that needs side effects)
var effects = {
    // verify registration
    verifyRegistration: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.VERIFY_REGISTRATION, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var fullname, email, username, password, verificationToken, getState, rejectWithValue, dispatch, ref, _register, _root, prevTempKey, type, emailStatus, response, _data, message, _data1, tempKey, status, state, nextForm, ref1, ref2, message1, ref3, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fullname = param.fullname, email = param.email, username = param.username, password = param.password, verificationToken = param.verificationToken, getState = param1.getState, rejectWithValue = param1.rejectWithValue, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, prevTempKey = _root.tempKey, type = _root.type, emailStatus = _root.emailStatus;
                        ;
                        if (!(type === constants/* registerTypes.FACEBOOK */.E8.FACEBOOK)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return auth/* default.verifyEmailRegistration */.Z.verifyEmailRegistration(prevTempKey, email, constants/* newRegisterTypes.FACEBOOK */.AY.FACEBOOK);
                    case 7:
                        response = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.next = 12;
                        return auth/* default.verifyRegistration */.Z.verifyRegistration({
                            fullname: fullname,
                            email: email,
                            username: username,
                            password: password,
                            verificationToken: verificationToken
                        });
                    case 12:
                        response = _ctx.sent;
                    case 13:
                        _data = response.data, message = _data.message, _data1 = _data.data, tempKey = _data1.key, status = _data1.status, state = _data1.state;
                        if (!(state === constants/* emailVerifyStatus.SIGNIN */.HH.SIGNIN)) {
                            _ctx.next = 16;
                            break;
                        }
                        throw new Error(constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED);
                    case 16:
                        nextForm = constants/* formTypes.VERIFY_EMAIL */.o_.VERIFY_EMAIL;
                        if (status === "verified") {
                            nextForm = constants/* formTypes.PHONE */.o_.PHONE;
                        } else {
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            tempKey: tempKey,
                            nextForm: nextForm,
                            type: type,
                            emailStatus: emailStatus
                        });
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        if (!((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) === constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED)) {
                            _ctx.next = 32;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        localStorage.setItem(constants/* LS_EMAIL_REGISTER */.hb, email);
                        router_default().push("/login");
                        // remove previous data from register form
                        dispatch(rootSlice.actions.resetAllData());
                        (0,utils/* removeData */.NU)();
                        return _ctx.abrupt("return", rejectWithValue(message1));
                    case 32:
                        (0,AlertErrorMessage/* default */.Z)(message1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        if (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.errors) {
                            ;
                            _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref3 = _ctx.t0.cause) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.errors) === null || ref4 === void 0 ? void 0 : ref4.map(function(e) {
                                var ref;
                                return dispatch(slice/* default.actions.storeFieldValidation */.ZP.actions.storeFieldValidation({
                                    field: e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                    message: e === null || e === void 0 ? void 0 : e.error,
                                    error: e === null || e === void 0 ? void 0 : e.error
                                }));
                            });
                        }
                        return _ctx.abrupt("return", rejectWithValue(message1));
                    case 35:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    21
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // verify email otp
    validateEmailOtp: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.VERIFY_EMAIL_OTP, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var code, getState, dispatch, ref, root, tempKey, response, _data, error_type, message, _data1, valid, emailStatus, ref1, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        code = param.code, getState = param1.getState, dispatch = param1.dispatch;
                        ref = getState(), root = ref.register.root;
                        _ctx.prev = 2;
                        tempKey = root.tempKey;
                        _ctx.next = 6;
                        return auth/* default.validateEmailOtp */.Z.validateEmailOtp(tempKey, code);
                    case 6:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 9:
                        _data = response.data, error_type = _data.error_type, message = _data.message, _data1 = _data.data, valid = _data1.valid, emailStatus = _data1.state;
                        if (!(emailStatus === constants/* emailVerifyStatus.SIGNIN */.HH.SIGNIN)) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED);
                    case 12:
                        if (!(error_type || !valid)) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(message);
                    case 14:
                        return _ctx.abrupt("return", {
                            message: response.data.message,
                            root: root
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        if (!(message1 === constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) === constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED)) {
                            _ctx.next = 28;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(constants/* errorMessage.EMAIL_REGISTERED */.N3.EMAIL_REGISTERED, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        localStorage.setItem(constants/* LS_EMAIL_REGISTER */.hb, root.email);
                        router_default().push("/login");
                        // remove previous data from register form
                        dispatch(rootSlice.actions.resetAllData());
                        (0,utils/* removeData */.NU)();
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 28:
                        (0,AlertErrorMessage/* default */.Z)(message1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // resend email otp
    resendEmailOtp: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.RESEND_EMAIL_OTP, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_, param) {
            var getState, ref, _register, _root, tempKey, email, type, response, message, ref1, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, email = _root.email, type = _root.type;
                        _ctx.next = 5;
                        return auth/* default.verifyEmailRegistration */.Z.verifyEmailRegistration(tempKey, email, constants/* mappingNewRegisterTypes */.Io[type]);
                    case 5:
                        response = _ctx.sent;
                        message = response.data.message;
                        (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        (0,AlertErrorMessage/* default */.Z)(message1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // verify phone
    verifyPhone: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.VERIFY_PHONE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var phoneNumber, code, channel, getState, dispatch, ref, root, prevTempKey, response, _data, error_type, message, _data1, tempKey, ref1, ref2, errorType, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        phoneNumber = param.phoneNumber, code = param.code, channel = param.channel, getState = param1.getState, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (!(!phoneNumber || !code)) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Phone number is required!");
                    case 4:
                        ref = getState(), root = ref.register.root;
                        prevTempKey = root.tempKey;
                        _ctx.next = 8;
                        return auth/* default.verifyPhoneRegistration */.Z.verifyPhoneRegistration(prevTempKey || undefined, code, phoneNumber.slice(code.length), channel);
                    case 8:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 11:
                        _data = response.data, error_type = _data.error_type, message = _data.message, _data1 = _data.data, tempKey = _data1.key;
                        if (!error_type) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(message);
                    case 14:
                        (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message,
                            tempKey: tempKey,
                            phoneNumber: phoneNumber,
                            code: code,
                            channel: channel,
                            root: root
                        });
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        errorType = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.errorType;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message;
                        if (errorType === VerifyPhoneErrorType.OtpLimit) {
                            dispatch(rootSlice.actions.changeForm({
                                target: constants/* formTypes.OTP_LIMIT */.o_.OTP_LIMIT
                            }));
                        } else {
                            dispatch(rootSlice.actions.changeForm({
                                target: constants/* formTypes.PHONE */.o_.PHONE
                            }));
                            (0,AlertErrorMessage/* default */.Z)(message1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        }
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // validate phone otp
    validatePhoneOtp: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.VERIFY_PHONE_OTP, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var otp, getState, dispatch, ref, _register, _root, tempKey, type, response, status, _data, _user, username, email, avatar, id, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        otp = param.otp, getState = param1.getState, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, type = _root.type;
                        _ctx.next = 5;
                        return (0,authNext/* verifyOTP */.qD)({
                            key: tempKey,
                            otp: otp
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!response.data.error_type) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(response.data.message);
                    case 8:
                        status = response.data.data.status;
                        if (!(status === constants/* phoneVerifyStatus.FAIL */.w7.FAIL)) {
                            _ctx.next = 12;
                            break;
                        }
                        dispatch(rootSlice.actions.changeForm({
                            target: constants/* formTypes.PHONE_ERROR */.o_.PHONE_ERROR
                        }));
                        throw new Error(constants/* errorMessage.PHONE_REGISTERED */.N3.PHONE_REGISTERED);
                    case 12:
                        if (!(status !== constants/* phoneVerifyStatus.SUCCESS */.w7.SUCCESS)) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(constants/* errorMessage.FAIL_TO_VERIFY_PHONE */.N3.FAIL_TO_VERIFY_PHONE);
                    case 14:
                        (0,clevertap/* clevertapEvent */.Lq)("Register Successful", {
                            "Register Method": type
                        });
                        _data = response.data.data, _user = _data.user, username = _user.username, email = _user.email, avatar = _user.avatar, id = _user.id;
                        (0,utils/* onUpdateAvatarIds */.px)(id);
                        (0,utils/* removeData */.NU)();
                        // create clevertap's user profile after success registration
                        // Track if username is empty
                        if (!username) {
                            (0,logger/* default */.ZP)(new Error("[CT initialization Error]: username is empty"), {
                                place: "src/features/register/slice.ts",
                                event: "validatePhoneOtp",
                                eventParam: {
                                    profile: response.data.data
                                }
                            });
                        }
                        // @ts-ignore
                        (0,clevertap/* clevertapProfilingUser */.$b)({
                            isInitProfile: true,
                            identity: username,
                            email: email,
                            profilePictureUrl: avatar
                        });
                        // save userdata to credentials entities
                        dispatch(credentials/* default.actions.loadCredentialsExodus */.ZP.actions.loadCredentialsExodus(response.data.data));
                        if (type === constants/* registerTypes.GOOGLE */.E8.GOOGLE || type === constants/* registerTypes.FACEBOOK */.E8.FACEBOOK) {
                            dispatch(rootSlice.actions.changeForm({
                                target: constants/* formTypes.SUCCESS */.o_.SUCCESS
                            }));
                        } else {
                            (0,AlertErrorMessage/* default */.Z)(response.data.message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        }
                        return _ctx.abrupt("return", {
                            message: response.data.message
                        });
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](1);
                        message = (0,utils/* formatErrorMessage */.jN)(_ctx.t0);
                        if (!(message === constants/* errorMessage.PHONE_REGISTERED */.N3.PHONE_REGISTERED)) {
                            _ctx.next = 30;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(message));
                    case 30:
                        (0,AlertErrorMessage/* default */.Z)(message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message));
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    25
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // resend phone otp
    resendPhoneOtp: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.RESEND_PHONE_OTP, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_, param) {
            var getState, ref, _register, _root, tempKey, phoneNumber, code, channel, response, _data, error_type, message, ref1, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, phoneNumber = _root.phoneNumber, code = _root.code, channel = _root.channel;
                        _ctx.next = 5;
                        return auth/* default.verifyPhoneRegistration */.Z.verifyPhoneRegistration(tempKey, String(code), phoneNumber.slice(String(code).length), channel);
                    case 5:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 8:
                        _data = response.data, error_type = _data.error_type, message = _data.message;
                        if (!error_type) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(message);
                    case 11:
                        (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        (0,AlertErrorMessage/* default */.Z)(message1, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Selectors (getters)
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.register.root;
}, function(root) {
    return root;
});
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    builder.addCase(effects.verifyRegistration.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.verifyRegistration.fulfilled, function(state, action) {
        var _arg = action.meta.arg, fullname = _arg.fullname, email = _arg.email, username = _arg.username, password = _arg.password, passwordConf = _arg.passwordConf;
        state.isLoading = false;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.password = password;
        state.passwordConf = passwordConf;
        state.tempKey = action.payload.tempKey;
        state.currentForm = action.payload.nextForm;
        state.type = action.payload.type;
        state.emailStatus = action.payload.emailStatus;
        (0,utils/* storeData */.xG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload.root), {
            isLoading: false,
            fullname: fullname,
            email: email,
            username: username,
            password: password,
            passwordConf: passwordConf,
            tempKey: action.payload.tempKey,
            type: action.payload.type,
            emailStatus: action.payload.emailStatus,
            currentForm: action.payload.nextForm
        }));
    }).addCase(effects.verifyRegistration.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    }).addCase(effects.validateEmailOtp.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.validateEmailOtp.fulfilled, function(state, action) {
        state.currentForm = constants/* formTypes.PHONE */.o_.PHONE;
        state.isLoading = false;
        (0,utils/* storeData */.xG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload.root), {
            isLoading: false,
            currentForm: constants/* formTypes.PHONE */.o_.PHONE
        }));
    }).addCase(effects.validateEmailOtp.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    }).addCase(effects.verifyPhone.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.verifyPhone.fulfilled, function(state, action) {
        state.isLoading = false;
        state.tempKey = action.payload.tempKey;
        state.phoneNumber = action.payload.phoneNumber;
        state.code = action.payload.code;
        state.channel = action.payload.channel;
        state.currentForm = constants/* formTypes.VERIFY_PHONE */.o_.VERIFY_PHONE;
        (0,utils/* storeData */.xG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.payload.root), {
            isLoading: false,
            phoneNumber: action.payload.phoneNumber,
            code: action.payload.code,
            tempKey: action.payload.tempKey,
            currentForm: constants/* formTypes.VERIFY_PHONE */.o_.VERIFY_PHONE
        }));
    }).addCase(effects.verifyPhone.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
var rootSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "register",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var register_slice = (rootSlice);


/***/ }),

/***/ 7865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kq": function() { return /* binding */ validatePasswordConf; },
/* harmony export */   "NU": function() { return /* binding */ removeData; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "px": function() { return /* binding */ onUpdateAvatarIds; },
/* harmony export */   "xG": function() { return /* binding */ storeData; },
/* harmony export */   "zj": function() { return /* binding */ handleRegistrationError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44252);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25516);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28456);









var storeData = function(data) {
    if (data && (0,constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isClient */ .C5)()) {
        var newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
            storedAt: moment__WEBPACK_IMPORTED_MODULE_0___default()()
        });
        localStorage.setItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP, JSON.stringify(newData));
    }
};
var removeData = function() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isClient */ .C5)()) {
        var data = localStorage.getItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP);
        if (data) {
            localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP);
        }
    }
};
var onUpdateAvatarIds = function(userId) {
    var ref;
    var avatarUserIds = ((ref = localStorage.getItem("avatarUserIds")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    if (!avatarUserIds.includes(userId)) {
        avatarUserIds.push(userId);
    }
    localStorage.setItem("avatarUserIds", avatarUserIds.join(","));
};
var formatErrorMessage = function(error) {
    var message;
    if (typeof error === "string") {
        message = error;
    } else {
        var ref, ref1;
        message = (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || (error === null || error === void 0 ? void 0 : error.message) || "";
    }
    message = message.replace(/;/g, ""); // Replace all occurrences of ';' with ''
    message = message.replace(" |error_type=1", "");
    return message;
};
var validateEmail = function(value) {
    // eslint-disable-next-line no-useless-escape
    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/)) {
        return {
            error: "Email format is not valid!",
            field: "email"
        };
    }
    return {
        message: "Email format is valid",
        field: "email"
    };
};
var validatePasswordConf = function(password, passwordConf) {
    if (password !== passwordConf) {
        return "Password dan Confirm Password tidak cocok";
    }
    return null;
};
var handleRegistrationError = function(responseMessage, email) {
    if (responseMessage === _constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.SOCIAL_ACCOUNT_REGISTERED */ .N3.SOCIAL_ACCOUNT_REGISTERED || responseMessage === _constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.SOCIAL_EMAIL_REGISTERED */ .N3.SOCIAL_EMAIL_REGISTERED) {
        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_5__/* .LS_EMAIL_REGISTER */ .hb, email);
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/login");
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.EMAIL_REGISTERED */ .N3.EMAIL_REGISTERED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
        return;
    }
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(responseMessage, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};


/***/ }),

/***/ 6242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var _instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var requestExodusNoError = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
var authRequestExodus = function(headersFromNextjsAPI) {
    var otherCustomHeader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false, undefined, true, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        "x-real-user-agent": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-real-user-agent"]) || "-",
        "x-forwarded-from-web-proxy": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-forwarded-from-web-proxy"]) || 1,
        "x-real-user-ip": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-real-user-ip"]) || "-",
        "x-forwarded-for": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-forwarded-for"]) || "-"
    }, otherCustomHeader));
};
/**
 * Email Login
 * @param {string} user - email / username
 * @param {string} password - password
 * @param {string} verificationToken - password
 * @param {string} recaptchaVersion - recaptchaVersion
 * @param {string} playerId - playerId
 */ var emailLogin = function(param, headersFromNextjsAPI) {
    var user = param.user, password = param.password, verificationToken = param.verificationToken, recaptchaVersion = param.recaptchaVersion, playerId = param.playerId;
    return authRequestExodus(headersFromNextjsAPI).post("/login/v3/username/browser", {
        user: user,
        password: password,
        verification_token: verificationToken,
        recaptcha_version: recaptchaVersion,
        player_id: playerId
    });
};
/**
 * Facebook Login
 * @param {string} id - facebook user id
 * @param {string} idToken - facebook access token
 * @param {string} playerId - player id
 */ var fbLogin = function(param, headersFromNextjsAPI) {
    var id = param.id, idToken = param.idToken, playerId = param.playerId;
    return authRequestExodus(headersFromNextjsAPI).post("/login/v4/facebook", {
        fb_userid: id,
        fb_token: idToken,
        player_id: playerId
    });
};
/**
 * Google Login
 * @param {string} id - google account id
 * @param {string} idToken - google access token
 * @param {string} playerId - player id
 */ var googleLogin = function(param, headersFromNextjsAPI) {
    var id = param.id, idToken = param.idToken, playerId = param.playerId;
    return authRequestExodus(headersFromNextjsAPI).post("/login/v4/google", {
        google_user_id: id,
        google_id_token: idToken,
        player_id: playerId
    });
};
var logout = function(param, headersFromNextjsAPI) {
    var token = param.token;
    return authRequestExodus(headersFromNextjsAPI).post("/logout", null, {
        headers: {
            Authorization: token
        }
    });
};
function validateRegisterForm(field, value, key) {
    var availableFields = [
        "fullname",
        "username",
        "password"
    ];
    if (availableFields.indexOf(field) < 0) {
        return Promise.reject(new Error("field is not available"));
    }
    return requestExodusNoError.post("/registration/check/".concat(field), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        key: key
    }, field, value));
}
/**
 * Forgot password request by email
 * @param {string} email - user email
 */ var forgotpassword = function(email) {
    return requestExodus.post("/user/setting/password/forgot", {
        email: email
    });
};
/**
 * Reset password
 * @param {string} userid - user id from link
 * @param {string} passkey - unique passkeyfrom link
 * @param {string} newpass - new password from form
 * @param {string} confirmpass - password confirmation from form
 *
 */ var resetPassword = function(userid, passkey, newpass, confirmpass) {
    return requestExodus.post("/user/setting/password/reset", {
        user_id: userid,
        token: passkey,
        password: newpass,
        confirm_password: confirmpass
    });
};
/**
 * Validate Social Media
 * @param {string} socialId
 * @param {string} socialToken
 * @param {string} email
 * @param {string} type
 * @returns {Promise<APIResponse>}
 */ var validateSocialMedia = function(socialId, socialToken, email, type) {
    return requestExodusNoError.post("/registration/check/sns-email", {
        social_id: socialId,
        social_token: socialToken,
        email: email,
        type: type
    });
};
var verifyRegistration = function(param) {
    var email = param.email, username = param.username, fullname = param.fullname, password = param.password, verificationToken = param.verificationToken;
    return requestExodusNoError.post("/registration/check/web", {
        email: email,
        username: username,
        fullname: fullname,
        password: password,
        verification_token: verificationToken
    });
};
/**
 * Verify Email Registration
 * @param {string} key
 * @param {string} email
 * @param {string} type
 * @returns {Promise<APIResponse>}
 */ var verifyEmailRegistration = function(key, email, type) {
    return requestExodusNoError.post("/registration/v3/check/email", {
        key: key,
        email: email,
        type: type
    });
};
/**
 * Valdidate Email OTP
 * @param {string} key
 * @param {string} otp
 * @returns {Promise<APIResponse>}
 */ var validateEmailOtp = function(key, otp) {
    return requestExodus.post("/registration/v3/otp/email", {
        key: key,
        otp: otp
    });
};
/**
 * Verify Phone Registration
 * @param {string} key
 * @param {string} code
 * @param {string} phone
 * @param {string} channel
 * @returns {Promise<APIResponse>}
 */ var verifyPhoneRegistration = function(key, code, phone, channel) {
    return _instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert.post */ .Z.noAlert.post("/registration/v3/check/phone", {
        key: key,
        code: code,
        phone: phone,
        channel: channel
    });
};
/**
 * Validate Phone OTP
 * @param {string} key
 * @param {string} otp
 * @returns {Promise<APIResponse>}
 */ var validatePhoneOtp = function(key, otp, headersFromNextjsAPI) {
    return authRequestExodus(headersFromNextjsAPI).post("/registration/v3/otp/phone", {
        key: key,
        otp: otp
    });
};
/**
 * Generate Registration Key
 * @returns {Promise<APIResponse>}
 */ var generateRegistrationKey = function() {
    return requestExodus.post("/registration/check/gen-key");
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    emailLogin: emailLogin,
    fbLogin: fbLogin,
    googleLogin: googleLogin,
    logout: logout,
    validateRegisterForm: validateRegisterForm,
    forgotpassword: forgotpassword,
    resetPassword: resetPassword,
    // NEW REGISTARTION FLOW
    verifyRegistration: verifyRegistration,
    validateSocialMedia: validateSocialMedia,
    verifyEmailRegistration: verifyEmailRegistration,
    validateEmailOtp: validateEmailOtp,
    verifyPhoneRegistration: verifyPhoneRegistration,
    validatePhoneOtp: validatePhoneOtp,
    generateRegistrationKey: generateRegistrationKey
});


/***/ }),

/***/ 49431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62974);

var MAX_USERNAME_LENGTH = 17;
function normalUsername(name) {
    var draft = name.replace(/\s/g, "").toLowerCase();
    if (draft.length > MAX_USERNAME_LENGTH) {
        return draft.substr(0, MAX_USERNAME_LENGTH);
    }
    return draft;
}
function randomUsername(name) {
    var draft = normalUsername(name);
    var randomNumber = _number__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getRandomInt */ .ZP.getRandomInt(1, 999);
    if (draft.length === MAX_USERNAME_LENGTH) {
        return "".concat(draft.substr(0, -3)).concat(randomNumber);
    }
    return "".concat(draft).concat(_number__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getRandomInt */ .ZP.getRandomInt(1, 999));
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    normalUsername: normalUsername,
    randomUsername: randomUsername
});


/***/ })

}]);